import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import React, { useState } from 'react';
import { collection, addDoc } from "firebase/firestore";
import { db } from "../utils/firebase.jsx";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
                message: '',
            });

            const handleChange = (e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            };

            // Set up state for submitted
            const [isSubmitted, setIsSubmitted] = useState(false);

            const [errors, setErrors] = useState({});

            const validate = (formData) => {
                let tempErrors = {};

                // Check if name is not empty
                if (!formData.name) {
                    tempErrors.name = "Name is required";
                }

                // Check if email is not empty and valid
                if (!formData.email) {
                    tempErrors.email = "Email is required";
                } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
                    tempErrors.email = "Email is not valid";
                }

                // Check if message is not empty
                if (!formData.message) {
                    tempErrors.message = "Message is required";
                }

                setErrors(tempErrors);

                // If no errors, return true, else return false
                return Object.keys(tempErrors).length === 0;
            };

            // Submit handler
            const handleSubmit = async (e) => {
                e.preventDefault();
                console.log(formData);

                // Validate form
                if (validate(formData)) {
                    try {
                        const docRef = await addDoc(collection(db, "contacts"), formData);
                        console.log("Document written with ID: ", docRef.id);
                        setIsSubmitted(true);
                        setFormData({
                            name: '',
                            email: '',
                            message: '',
                        }); // Clear form data
                    } catch (e) {
                        console.error("Error adding document: ", e);
                    }
                }
            };

            return (
            <section className="bg-user-home user-pages d-flex align-items-center">
                <div className="bg-overlay bg-overlay-white" />
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8">
                    <div className="login-page bg-white shadow-lg rounded p-4 mt-4 position-relative">
                    <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="name">Name:</label>
                                    <input type="text" className={`form-control ${isSubmitted ? 'shake border-transition' : ''}`} id="name" value={formData.name} name="name" onChange={handleChange} />
                                    {errors.name && <p className='errorMsg'>{errors.name}</p>}
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="email">Email:</label>
                                    <input type="email" className={`form-control ${isSubmitted ? 'shake border-transition' : ''}`} id="email" name="email" value={formData.email} onChange={handleChange} />
                                    {errors.email && <p className='errorMsg'>{errors.email}</p>}
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="message">Message:</label>
                                    <textarea className={`form-control ${isSubmitted ? 'shake border-transition' : ''}`}  id="message" name="message" value={formData.message} onChange={handleChange} />
                                    {errors.message && <p className='errorMsg'>{errors.message}</p>}
                                </div>
                                {isSubmitted ? (
                                <p>Message sent</p>
                                ) : (
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                )}
                                
                            </form>
                        </div>

                      {/*end login*/}
                    </div>
                    {/*end col*/}
                  </div>
                  {/*end row*/}
                </div>
              </section>
            );
        };

export default Contact;